var _defs, _sodipodiNamedview;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOxBrandCmykPosRect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 614.17334,
    height: 188.97333,
    viewBox: "0 0 614.17334 188.97333",
    sodipodiDocname: "ox_brand_cmyk_pos_rect.eps",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "ink_ext_XXXXXX",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,188.97333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4606.3,0 H 0 V 1417.33 H 4606.3 V 0",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1804.26,531.125 c 0,119.441 -57.9,202.777 -155.59,202.777 -106.2,0 -155.73,-100.082 -155.73,-202.777 0,-119.375 57.95,-202.645 155.73,-202.645 106.17,0 155.59,100.055 155.59,202.645 v 0 z m 72.47,2.371 c 0,-131.367 -101.38,-226.734 -228.06,-226.734 -129.14,0 -228.11,96.437 -228.11,222.039 0,131.445 101.37,226.82 228.11,226.82 129.13,0 228.06,-96.566 228.06,-222.125 v 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3196.89,531.125 c 0,119.441 -57.97,202.777 -155.66,202.777 -106.2,0 -155.67,-100.082 -155.67,-202.777 0,-119.375 57.93,-202.645 155.67,-202.645 106.16,0 155.66,100.055 155.66,202.645 v 0 z m 72.4,2.371 c 0,-131.367 -101.38,-226.734 -228.06,-226.734 -129.16,0 -228.1,96.437 -228.1,222.039 0,131.445 101.38,226.82 228.1,226.82 129.11,0 228.06,-96.566 228.06,-222.125 v 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3545.64,458.848 c -25.37,36.191 -35.04,49.394 -66.38,49.394 h -33.82 V 361.02 c 0,-12.071 4.85,-18.008 18.15,-20.469 l 49.45,-10.852 V 313.93 h -194.29 v 15.769 l 44.67,10.852 c 13.24,3.551 18.08,8.398 18.08,20.469 v 340.308 c 0,12.098 -4.84,16.891 -18.08,20.485 l -44.67,10.875 v 15.742 h 189.45 c 39.87,0 67.6,-3.668 90.53,-12.051 47.07,-18.16 73.59,-62.883 73.59,-105 0,-53.176 -39.81,-97.883 -106.19,-113.391 v -2.422 c 13.3,-6.152 20.53,-14.55 67.59,-76.179 l 59.13,-78.367 c 8.43,-12.071 19.31,-19.239 32.59,-21.719 l 43.44,-9.602 V 313.93 h -103.77 c -12.07,0 -18.1,3.691 -28.96,18.218 l -90.51,126.7 z m -100.2,69.953 h 54.32 c 82.08,0 100.2,51.785 100.2,101.347 0,37.411 -16.92,72.411 -55.53,89.262 -20.51,8.477 -39.84,8.477 -66.38,8.477 h -32.61 v -199.086 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2694.88,599.98 H 2713 V 455.137 h -18.12 l -10.87,43.418 c -3.64,15.761 -13.27,21.75 -27.75,21.75 H 2551.25 V 361.02 c 0,-12.071 4.84,-18.008 18.12,-20.469 l 49.47,-10.852 V 313.93 h -194.26 v 15.769 l 44.65,10.852 c 13.27,3.551 18.11,8.398 18.11,20.469 v 340.308 c 0,12.098 -4.84,16.891 -18.11,20.485 l -44.65,10.875 V 748.43 H 2752.8 V 639.707 h -18.1 l -20.51,65.254 c -4.82,16.852 -12.07,22.926 -26.56,22.926 H 2551.25 V 540.859 h 105.01 c 14.48,0 22.91,5.957 27.75,21.731 l 10.87,37.39 v 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3930.58,727.887 V 353.859 c 0,-15.769 3.59,-19.461 19.31,-19.461 h 53.08 c 50.7,0 88.1,7.383 114.64,26.622 44.65,32.55 65.18,91.675 65.18,166.539 0,73.605 -20.53,145.937 -80.84,180.968 -25.33,14.528 -57.93,19.36 -108.64,19.36 h -62.73 z M 3803.84,313.93 v 15.769 l 44.66,10.852 c 13.29,3.551 18.1,8.398 18.1,20.469 v 340.308 c 0,12.098 -4.81,16.891 -18.1,20.485 l -44.66,10.875 v 15.742 h 203.97 c 55.5,0 95.33,-7.25 127.93,-21.735 82.05,-37.437 119.47,-118.257 119.47,-197.894 0,-77.336 -28.98,-149.653 -102.58,-188.25 -33.77,-18.211 -80.86,-26.621 -142.38,-26.621 h -206.41 v 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2046.89,329.699 V 313.93 h -153.25 v 15.769 l 38.56,9.602 c 14.55,3.711 24.14,8.418 33.79,19.258 l 132.77,166.55 -132.77,176.219 c -8.42,12.098 -19.24,18.082 -32.57,21.727 l -36.22,9.633 v 15.742 h 190.68 v -15.742 l -40.99,-8.415 c -14.51,-2.46 -10.89,-8.453 -3.67,-18.14 l 97.75,-139.969 h 2.41 l 100.17,139.969 c 7.25,9.687 9.69,13.277 -3.61,16.922 l -38.62,9.633 v 15.742 h 153.26 v -15.742 l -38.63,-9.633 c -14.44,-3.645 -24.11,-8.426 -33.79,-19.285 L 2156.67,545.586 2296.64,361.02 c 8.49,-12.071 19.31,-18.008 32.59,-21.719 l 36.23,-9.602 V 313.93 h -190.68 v 15.769 l 41.02,8.391 c 14.5,2.461 12.08,7.16 4.83,17.012 l -106.2,149.605 h -2.4 l -107.4,-148.598 c -7.25,-9.621 -9.66,-13.097 3.61,-16.808 l 38.65,-9.602 v 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1589.76,952.879 c -12,-11.992 -30,-20.008 -55.12,-20.008 -21.89,0 -42.18,6.895 -55.92,20.633 -18.75,18.738 -17.89,42.648 -17.89,68.206 v 120.84 h 24.65 v -129.82 c 0,-16.421 -0.5,-32.421 12.19,-45.117 8.79,-8.785 22.33,-13.535 37.92,-13.535 15.23,0 27.46,5.25 35.07,12.883 14.12,14.109 13.22,29.5 13.22,66.679 v 108.91 h 24.28 v -102.51 c 0,-38.95 1.58,-67.188 -18.4,-87.161",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1808.45,936.742 -99.14,168.708 0.62,-168.708 h -22.65 v 205.818 h 25.25 l 99.52,-169.642 -0.63,169.642 h 22.66 V 936.742 h -25.63",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1919.88,936.766 v 205.784 h 24.76 V 936.766 h -24.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2098.61,936.766 h -28.35 l -70.96,205.784 h 25.81 l 60.02,-181.679 61.82,181.679 h 23.96 l -72.3,-205.784",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2226.92,936.766 v 205.784 h 111.9 v -20.52 h -87.63 v -67.92 h 82.26 v -20.01 h -82.26 v -76.198 h 90.07 v -21.136 h -114.34",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2520.19,936.766 -23.63,53.336 c -14.65,32.808 -21.33,36.168 -51.17,36.168 h -14.34 v -89.504 h -24.28 v 205.784 h 44.41 c 27.46,0 48.17,0.18 64.36,-16.01 10.29,-10.29 16.05,-23.99 16.05,-41.15 0,-14.3 -4.16,-26.2 -12.77,-35.37 -7.41,-7.88 -19.66,-14.8 -33.01,-16.23 7.25,-0.41 13.24,-4.32 17.11,-8.22 5.61,-5.59 9.69,-14.07 15.72,-27.531 l 27.33,-61.273 z m -22.47,174.804 c -11.79,11.81 -27.1,11.26 -43.88,11.26 h -22.79 v -76.85 h 8.18 c 20.77,0 43.15,-1.08 57.27,13.04 6.81,6.82 10.63,16.39 10.63,26.83 0,11.57 -4.56,20.86 -9.41,25.72",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2786.36,936.766 v 205.784 h 24.77 V 936.766 h -24.77",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2952.4,1122.03 V 936.766 h -24.73 v 185.264 h -61.19 v 20.52 h 146.91 v -20.52 h -60.99",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3131.84,1018.1 v -81.334 h -24.45 v 81.334 l -65.32,124.45 h 28.3 l 50.7,-96.51 49.27,96.52 26.83,-0.01 -65.33,-124.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3428.09,932.871 c -53.25,0 -92.21,43.988 -92.21,105.859 0,63.55 38.53,107.72 94.12,107.72 53.86,0 91.91,-43.7 91.91,-105.83 0,-63.71 -38.12,-107.749 -93.82,-107.749 z m -0.08,192.549 c -40.32,0 -66.5,-34.06 -66.5,-85.38 0,-51.138 29.15,-85.962 67.83,-85.962 43,0 66.94,36.594 66.94,87.582 0,50.21 -28.26,83.76 -68.27,83.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3614.14,1122.03 v -67.92 h 79.57 v -20.01 h -79.57 v -97.334 h -24.57 v 205.784 h 109.29 v -20.52 h -84.72",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2595.85,1092.34 c 0,31.62 25.44,54.14 62.62,54.14 37.64,0 55.69,-19.43 57.53,-21.44 l -12.08,-14.62 c -4.61,3.55 -21.08,15.65 -43.83,15.65 -26.25,0 -40.79,-13.71 -40.79,-32.34 0,-9.02 3.7,-15.5 9.63,-20.83 7.07,-6.33 17.36,-11.01 28.45,-16.12 13.81,-6.34 32.71,-13.47 45.39,-26.62 8.77,-9.09 15.39,-20.91 15.39,-37.133 0,-34.226 -23.75,-60.293 -66.47,-60.293 -36.4,0 -59.37,20.051 -61.53,22.059 l 11.34,16.691 c 5.84,-4.339 28.69,-17.855 49.59,-17.855 30.97,0 42.55,16.953 42.55,37.398 0,9.503 -4.31,17.153 -10.73,23.293 -9.6,9.25 -24.13,15.44 -38.05,21.81 -13.83,6.31 -27.15,12.93 -36.58,22.83 -6.22,6.54 -12.43,17.2 -12.43,33.38",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 704.469,863.516 c 0,18.199 -6.164,32.882 -19.492,40.711 -8.352,4.906 -19.649,6.507 -33.594,6.507 L 549.938,910.75 V 705.93 h 110.398 c 25.461,0 40.422,-5.735 41.719,-28.555 h 2.422 l -0.008,186.141",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 718.637,863.516 c 0,18.199 6.172,32.882 19.492,40.711 8.371,4.906 19.68,6.507 33.625,6.507 l 102.148,0.016 V 705.93 H 762.789 c -25.449,0 -40.41,-5.735 -41.719,-28.555 h -2.441 l 0.008,186.141",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 895.258,895.602 c 0,0 0,-203.239 0,-216.52 -12.899,0 -157,0 -157,0 l -1.789,-4.422 c -2.723,-6.758 -7.625,-13.008 -24.746,-13.008 -17.118,0 -21.981,6.25 -24.735,13.008 l -1.797,4.422 c 0,0 -143.652,0 -156.57,0 0,13.281 0,216.52 0,216.52 h -14.164 v -6.59 l -13.582,4.168 c -1.574,5.347 -6.465,9.277 -12.316,9.277 -7.11,0 -12.899,-5.781 -12.899,-12.898 0,-7.129 5.789,-12.903 12.899,-12.903 3.113,0 5.933,1.149 8.156,2.985 l 17.742,-5.446 v -17.406 l -13.336,2.387 c -1.965,4.597 -6.535,7.832 -11.859,7.832 -7.11,0 -12.895,-5.778 -12.895,-12.903 0,-7.128 5.785,-12.894 12.895,-12.894 3.683,0 6.984,1.562 9.332,4.027 l 15.863,-2.84 v -17.75 l -13.934,0.618 c -2.253,3.754 -6.324,6.297 -11.019,6.297 -7.109,0 -12.902,-5.782 -12.902,-12.895 0,-7.129 5.793,-12.906 12.902,-12.906 4.297,0 8.074,2.125 10.418,5.355 l 14.535,-0.637 v -19.289 l -14.238,-0.507 c -2.344,3.277 -6.153,5.429 -10.485,5.429 -7.105,0 -12.894,-5.773 -12.894,-12.894 0,-7.125 5.789,-12.903 12.894,-12.903 4.664,0 8.711,2.508 10.985,6.211 l 13.738,0.496 V 759.25 l -15.574,-2.676 c -2.356,2.504 -5.676,4.098 -9.379,4.098 -7.109,0 -12.902,-5.777 -12.902,-12.902 0,-7.125 5.793,-12.895 12.902,-12.895 5.285,0 9.828,3.191 11.812,7.75 l 13.141,2.258 v -17.445 l -17.031,-5.2 c -2.227,1.836 -5.047,2.989 -8.164,2.989 -7.11,0 -12.895,-5.778 -12.895,-12.903 0,-7.129 5.785,-12.89 12.895,-12.89 5.855,0 10.742,3.918 12.32,9.261 l 12.875,3.938 v -16.871 l -18.812,-8.125 c -2.036,1.347 -4.469,2.14 -7.086,2.14 -7.11,0 -12.899,-5.773 -12.899,-12.902 0,-7.117 5.789,-12.898 12.899,-12.898 6.347,0 11.601,4.597 12.668,10.652 l 13.23,5.703 v -15.41 c 0,0 154.512,0 162.012,0 6.594,-11.484 17.98,-17.43 35.254,-17.43 17.285,0 28.683,5.946 35.254,17.43 7.511,0 162.441,0 162.441,0 v 230.68 h -14.16",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 605.133,967.809 c -32.754,0 -59.289,-5.094 -59.289,-11.371 0,-6.29 26.535,-11.375 59.289,-11.375 32.742,0 59.285,5.085 59.285,11.375 0,6.277 -26.543,11.371 -59.285,11.371",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 686.762,1038.84 -34.219,-24.05 -0.293,-2.45 8.125,-3.65 c 1.633,-0.8 1.633,-2.1 0.813,-2.88 l -21.504,-18.142 -2.032,0.176 -15.226,22.446 c -1.063,1.46 -0.672,2.91 1.164,3.22 l 10.215,1.67 v 2.57 l -26.504,37.45 h -4.356 l -26.504,-37.45 v -2.57 l 10.235,-1.67 c 1.824,-0.31 2.207,-1.76 1.16,-3.22 l -15.242,-22.446 -2.024,-0.176 -20.086,18.142 c -0.812,0.78 -0.812,2.08 0.801,2.88 l 8.133,3.65 -0.293,2.45 -35.648,24.05 -2.891,-1.13 20.922,-63.96 c 10.637,4.77 35.039,8.137 63.605,8.266 28.594,-0.129 52.989,-3.496 63.614,-8.266 l 20.937,63.96 -2.902,1.13",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 711.469,538.926 c -32.754,0 -59.297,-5.098 -59.297,-11.367 0,-6.289 26.543,-11.375 59.297,-11.375 32.746,0 59.289,5.086 59.289,11.375 0,6.269 -26.543,11.367 -59.289,11.367",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 793.102,609.961 -34.219,-24.063 -0.293,-2.441 8.133,-3.652 c 1.613,-0.801 1.621,-2.09 0.812,-2.871 l -21.504,-18.153 -2.051,0.184 -15.226,22.441 c -1.043,1.465 -0.672,2.91 1.172,3.223 l 10.226,1.66 v 2.578 l -26.515,37.453 h -4.344 l -26.504,-37.453 v -2.578 l 10.223,-1.66 c 1.828,-0.313 2.207,-1.758 1.164,-3.223 l -15.246,-22.441 -2.039,-0.184 -20.059,18.153 c -0.832,0.781 -0.82,2.07 0.801,2.871 l 8.125,3.652 -0.293,2.441 -35.656,24.063 -2.891,-1.133 20.949,-63.965 c 10.625,4.785 35.02,8.145 63.594,8.274 28.582,-0.129 52.988,-3.489 63.613,-8.274 l 20.926,63.965 -2.898,1.133",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 817.574,967.809 c -32.773,0 -59.316,-5.094 -59.316,-11.371 0,-6.29 26.543,-11.375 59.316,-11.375 32.723,0 59.258,5.085 59.258,11.375 0,6.277 -26.535,11.371 -59.258,11.371",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 899.184,1038.84 -34.219,-24.05 -0.301,-2.45 8.133,-3.65 c 1.613,-0.8 1.621,-2.1 0.801,-2.88 l -21.493,-18.142 -2.031,0.176 -15.234,22.446 c -1.055,1.46 -0.664,2.91 1.16,3.22 l 10.215,1.67 v 2.57 l -26.504,37.45 h -4.344 l -26.504,-37.45 v -2.57 l 10.223,-1.67 c 1.836,-0.31 2.219,-1.76 1.172,-3.22 l -15.223,-22.446 -2.062,-0.176 -20.067,18.382 c -0.82,0.78 -0.812,2.08 0.801,2.88 l 8.133,3.41 -0.293,2.45 -35.664,24.05 -2.879,-1.13 20.926,-63.96 c 10.617,4.77 35.031,8.137 63.613,8.266 28.586,-0.129 52.969,-3.496 63.594,-8.266 l 20.949,63.96 -2.902,1.13",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 573.922,856.082 c 0,-4.016 1.004,-4.785 3.164,-4.785 3.887,0 7.812,4.285 7.812,12.285 0,9.699 -4.921,12.41 -8.761,12.41 -1.043,0 -1.629,-0.14 -1.942,-0.32 -0.234,-0.086 -0.273,-1.129 -0.273,-2.254 z m 2.215,22.172 c 5.558,0 10.168,-1.09 13.183,-4.02 2.121,-2.035 3.879,-5.375 3.879,-9.257 0,-11.247 -8.527,-16.075 -18.965,-16.075 h -11.64 v 1.758 c 3.289,0.274 3.66,0.59 3.66,5.465 v 14.902 c 0,4.871 -0.371,5.196 -3.309,5.457 v 1.77 h 13.192",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 605.523,864.707 c 0,-8.18 3.067,-14.137 7.5,-14.137 3.895,0 5.997,3.746 5.997,11.926 0,9.067 -3.243,14.082 -7.129,14.082 -3.469,0 -6.368,-3.976 -6.368,-11.871 z m 21.903,-0.769 c 0,-9.668 -6.59,-15.715 -15.254,-15.715 -9.121,0 -15.039,6.64 -15.039,14.949 0,7.312 4.875,15.754 15.664,15.754 8.254,0 14.629,-6.047 14.629,-14.988",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 667.301,878.254 v -1.77 c -3.449,-0.316 -3.625,-0.492 -3.477,-5.238 l 0.438,-15.121 c 0.148,-5.012 0.246,-5.148 3.488,-5.465 v -1.758 h -14.121 v 1.758 c 3.379,0.317 3.504,0.453 3.457,5.465 l -0.117,15.891 h -0.196 l -8.71,-22.621 h -2.434 l -8.27,21.039 h -0.097 l -0.313,-10.024 c -0.129,-3.883 -0.078,-6.043 0.098,-7.441 0.176,-1.672 1.172,-2.082 4.101,-2.309 v -1.758 h -11.144 v 1.758 c 2.168,0.188 3.019,0.637 3.293,2.309 0.234,1.398 0.496,3.789 0.723,7.902 l 0.488,9.113 c 0.332,5.688 -0.039,6.184 -3.594,6.5 v 1.77 h 10.606 l 7.898,-17.883 6.906,17.883 h 10.977",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 681.969,856.125 c 0,-4.875 0.351,-5.191 3.465,-5.465 v -1.758 h -14.629 v 1.758 c 3.117,0.274 3.488,0.59 3.488,5.465 v 14.902 c 0,4.871 -0.371,5.196 -3.488,5.457 v 1.77 h 14.629 v -1.77 c -3.114,-0.261 -3.465,-0.586 -3.465,-5.457 v -14.902",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 609.254,794.406 h -3.879 l -16.699,21.313 h -0.106 v -8.305 c 0,-4.742 0.184,-7.223 0.36,-8.625 0.226,-1.586 1.445,-2.168 4.425,-2.309 v -1.757 h -11.23 v 1.757 c 1.973,0.098 3.145,0.723 3.379,2.309 0.176,1.402 0.351,3.883 0.351,8.625 v 8.305 c 0,3.34 -0.089,3.929 -0.996,5.195 -0.664,0.945 -1.789,1.254 -3.418,1.395 v 1.765 h 9.981 l 15.019,-18.742 h 0.106 v 6.051 c 0,4.746 -0.184,7.226 -0.371,8.625 -0.215,1.574 -1.453,2.16 -4.422,2.301 v 1.765 h 11.504 v -1.765 c -2.246,-0.09 -3.418,-0.727 -3.653,-2.301 -0.175,-1.399 -0.351,-3.879 -0.351,-8.625 v -16.977",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 627.543,794.406 c -3.125,8.129 -7.371,19.282 -8.992,23.524 -1.485,3.883 -2.383,4.113 -4.551,4.379 v 1.765 h 14.57 v -1.765 l -1.523,-0.18 c -1.672,-0.18 -1.672,-0.586 -1.172,-2.172 0.801,-2.519 4.375,-11.422 6.043,-15.844 1.398,3.836 4.297,12.461 5.012,14.582 0.945,2.762 0.672,3.254 -1.348,3.473 l -1.367,0.141 v 1.765 h 10.945 v -1.765 c -2.586,-0.317 -3.211,-0.543 -4.988,-4.653 -0.274,-0.625 -5.781,-14.039 -9.16,-23.25 h -3.469",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 647.906,804.023 c 0.938,-2.621 3.602,-7.632 8.047,-7.632 2.344,0 4.141,1.539 4.141,4.472 0,2.664 -1.758,4.153 -4.512,5.418 l -0.684,0.321 c -3.691,1.714 -7.89,4.058 -7.89,8.886 0,5.106 3.691,9.266 10.781,9.266 1.395,0 2.84,-0.184 4.16,-0.547 1.024,-0.269 1.758,-0.445 2.344,-0.637 0.176,-1.757 0.488,-3.968 0.996,-7.035 l -1.992,-0.316 c -0.996,2.976 -2.57,6.179 -6.133,6.179 -2.316,0 -3.937,-1.757 -3.937,-3.925 0,-2.254 1.769,-3.567 4.648,-4.879 l 0.988,-0.453 c 4.18,-1.895 7.723,-4.2 7.723,-9.477 0,-5.555 -4.461,-9.613 -11.453,-9.613 -1.817,0 -3.672,0.355 -4.883,0.765 -1.348,0.454 -2.305,0.809 -2.832,1.082 -0.371,2.079 -0.957,4.512 -1.496,7.536 l 1.984,0.589",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 589.176,747.77 c 0,-4.875 0.351,-5.184 3.476,-5.465 v -1.758 h -14.629 v 1.758 c 3.106,0.281 3.477,0.59 3.477,5.465 v 14.902 c 0,4.875 -0.371,5.191 -3.477,5.461 v 1.762 h 14.629 v -1.762 c -3.125,-0.27 -3.476,-0.586 -3.476,-5.461 V 747.77",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 607.047,747.184 c 0,-2.348 0.086,-3.473 0.898,-3.883 0.731,-0.36 1.766,-0.406 3.164,-0.406 1.446,0 3.399,0.128 4.336,1.316 0.731,0.848 1.485,2.07 2.215,4.461 l 1.945,-0.317 c -0.265,-1.714 -1.222,-6.41 -1.632,-7.808 H 595.59 v 1.758 c 3.418,0.281 3.789,0.59 3.789,5.465 v 14.902 c 0,4.875 -0.371,5.191 -3.387,5.461 v 1.762 h 14.676 v -1.762 c -3.25,-0.27 -3.621,-0.586 -3.621,-5.461 v -15.488",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 632.25,747.184 c 0,-2.348 0.09,-3.473 0.891,-3.883 0.722,-0.36 1.757,-0.406 3.164,-0.406 1.453,0 3.398,0.128 4.336,1.316 0.722,0.848 1.492,2.07 2.207,4.461 l 1.953,-0.317 c -0.274,-1.714 -1.231,-6.41 -1.633,-7.808 h -22.391 v 1.758 c 3.438,0.281 3.789,0.59 3.789,5.465 v 14.902 c 0,4.875 -0.351,5.191 -3.39,5.461 v 1.762 h 14.679 v -1.762 c -3.261,-0.27 -3.605,-0.586 -3.605,-5.461 v -15.488",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 653.824,740.23 c -3.125,8.125 -7.363,19.278 -8.984,23.528 -1.496,3.875 -2.402,4.105 -4.57,4.375 v 1.762 h 14.589 v -1.762 l -1.543,-0.176 c -1.66,-0.184 -1.66,-0.59 -1.152,-2.176 0.801,-2.523 4.375,-11.422 6.035,-15.843 1.395,3.835 4.297,12.457 5.02,14.585 0.957,2.754 0.683,3.25 -1.367,3.469 l -1.34,0.141 v 1.762 h 10.918 v -1.762 c -2.578,-0.317 -3.203,-0.543 -4.969,-4.656 -0.285,-0.625 -5.781,-14.039 -9.16,-23.247 h -3.477",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 775.094,878.254 v -1.77 c -3.438,-0.316 -3.625,-0.492 -3.477,-5.238 l 0.438,-15.121 c 0.148,-5.012 0.246,-5.148 3.488,-5.465 v -1.758 h -14.121 v 1.758 c 3.379,0.317 3.504,0.453 3.457,5.465 l -0.129,15.891 h -0.184 l -8.722,-22.621 h -2.422 l -8.25,21.039 h -0.098 L 744.75,860.41 c -0.125,-3.883 -0.086,-6.043 0.09,-7.441 0.164,-1.672 1.16,-2.082 4.101,-2.309 v -1.758 h -11.144 v 1.758 c 2.168,0.188 3.019,0.637 3.293,2.309 0.234,1.398 0.496,3.789 0.723,7.902 l 0.488,9.113 c 0.332,5.688 -0.02,6.184 -3.594,6.5 v 1.77 h 10.606 l 7.898,-17.883 6.914,17.883 h 10.969",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 789.75,856.125 c 0,-4.875 0.363,-5.191 3.477,-5.465 v -1.758 h -14.629 v 1.758 c 3.117,0.274 3.488,0.59 3.488,5.465 v 14.902 c 0,4.871 -0.371,5.196 -3.488,5.457 v 1.77 h 14.629 v -1.77 c -3.114,-0.261 -3.477,-0.586 -3.477,-5.457 v -14.902",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 823.344,848.586 h -3.875 l -16.711,21.312 h -0.086 v -8.308 c 0,-4.738 0.176,-7.223 0.371,-8.621 0.223,-1.586 1.434,-2.172 4.422,-2.309 v -1.758 h -11.25 v 1.758 c 1.984,0.098 3.164,0.723 3.379,2.309 0.187,1.398 0.371,3.883 0.371,8.621 v 8.308 c 0,3.336 -0.086,3.926 -0.996,5.192 -0.672,0.945 -1.805,1.258 -3.418,1.394 v 1.77 h 9.961 l 15.051,-18.742 h 0.066 v 6.051 c 0,4.742 -0.164,7.222 -0.34,8.621 -0.246,1.578 -1.445,2.164 -4.445,2.3 v 1.77 h 11.535 v -1.77 c -2.266,-0.086 -3.449,-0.722 -3.664,-2.3 -0.164,-1.399 -0.371,-3.879 -0.371,-8.621 v -16.977",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 836.5,860.461 h 5.762 l -2.844,8.629 h -0.125 z m 5.711,-9.801 1.359,0.188 c 1.688,0.218 1.766,0.672 1.18,2.3 l -1.621,4.602 h -7.41 l -1.348,-4.332 c -0.586,-1.945 -0.586,-2.398 1.473,-2.621 l 1.32,-0.137 v -1.758 h -10.527 v 1.758 c 2.324,0.317 2.996,0.504 4.492,4.293 l 9.023,23.34 3.106,0.633 3.086,-8.535 c 1.922,-5.371 3.867,-10.703 5.574,-15.305 1.457,-3.922 2.266,-4.152 4.484,-4.426 v -1.758 h -14.191 v 1.758",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 774.742,801.949 c 0,-4.875 0.352,-5.191 4.141,-5.469 v -1.757 H 763.09 v 1.757 c 3.594,0.278 3.965,0.594 3.965,5.469 v 19.778 h -0.762 c -3.027,0 -4.246,-0.547 -4.969,-1.364 -0.527,-0.672 -1.094,-1.847 -1.66,-4.375 h -1.906 c 0.176,3.793 0.461,6.907 0.539,9.207 h 1.387 c 0.691,-1.027 1.152,-1.121 2.363,-1.121 h 18.008 c 1.191,0 1.406,0.274 2.117,1.121 h 1.418 c 0.039,-1.894 0.262,-5.73 0.488,-9.066 l -1.992,-0.141 c -0.664,2.707 -1.164,3.879 -1.836,4.653 -0.781,0.816 -2.277,1.086 -4.445,1.086 h -1.063 v -19.778",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 798.375,801.949 c 0,-4.875 0.371,-5.191 3.465,-5.469 v -1.757 h -14.629 v 1.757 c 3.125,0.278 3.488,0.594 3.488,5.469 v 14.899 c 0,4.879 -0.363,5.195 -3.488,5.461 v 1.765 h 14.629 v -1.765 c -3.094,-0.266 -3.465,-0.582 -3.465,-5.461 v -14.899",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 814.008,810.531 c 0,-8.176 3.078,-14.14 7.5,-14.14 3.898,0 5.996,3.75 5.996,11.925 0,9.075 -3.242,14.082 -7.129,14.082 -3.465,0 -6.367,-3.968 -6.367,-11.867 z m 21.906,-0.773 c 0,-9.664 -6.594,-15.707 -15.254,-15.707 -9.121,0 -15.031,6.637 -15.031,14.937 0,7.317 4.855,15.766 15.656,15.766 8.262,0 14.629,-6.059 14.629,-14.996",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 788.063,769.895 v -1.762 c -3.438,-0.317 -3.614,-0.5 -3.477,-5.242 l 0.457,-15.121 c 0.129,-5.008 0.215,-5.153 3.457,-5.465 v -1.758 h -14.121 v 1.758 c 3.379,0.312 3.527,0.457 3.469,5.465 l -0.129,15.898 h -0.184 l -8.711,-22.625 h -2.441 l -8.254,21.039 h -0.106 l -0.312,-10.023 c -0.137,-3.883 -0.078,-6.047 0.098,-7.446 0.175,-1.672 1.16,-2.082 4.109,-2.308 v -1.758 h -11.16 v 1.758 c 2.168,0.187 3.035,0.636 3.301,2.308 0.234,1.399 0.496,3.789 0.722,7.903 l 0.489,9.117 c 0.32,5.687 -0.02,6.183 -3.594,6.5 v 1.762 h 10.605 l 7.899,-17.879 6.906,17.879 h 10.977",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 795.043,762.672 c 0,4.875 -0.371,5.191 -3.367,5.461 v 1.762 h 21.387 c 0.058,-0.774 0.273,-4.071 0.496,-7.45 l -1.981,-0.136 c -0.449,2.214 -0.957,3.472 -1.68,4.195 -0.714,0.773 -2.218,1.043 -4.601,1.043 h -0.77 c -1.699,0 -1.808,0 -1.808,-1.578 v -8.711 h 2.246 c 3.887,0 4.035,0.265 4.504,3.695 h 1.961 v -10.648 h -1.961 c -0.469,3.965 -0.617,4.242 -4.504,4.242 h -2.246 v -7.363 c 0,-2.348 0.109,-3.473 0.91,-3.883 0.723,-0.36 1.758,-0.406 3.164,-0.406 1.805,0 3.797,0.269 4.785,1.347 0.762,0.817 1.543,2.488 2.215,4.66 l 1.973,-0.316 c -0.203,-2.211 -1.172,-6.816 -1.582,-8.039 h -22.969 v 1.758 c 3.457,0.281 3.828,0.59 3.828,5.465 v 14.902",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 825.883,752.105 h 5.793 l -2.852,8.622 h -0.148 z m 5.742,-9.8 1.348,0.187 c 1.66,0.219 1.769,0.672 1.183,2.305 l -1.64,4.598 h -7.383 l -1.379,-4.336 c -0.586,-1.942 -0.586,-2.391 1.496,-2.618 l 1.297,-0.136 v -1.758 h -10.496 v 1.758 c 2.285,0.312 2.988,0.504 4.461,4.293 l 9.035,23.34 3.125,0.632 3.047,-8.531 c 1.953,-5.379 3.886,-10.703 5.605,-15.309 1.465,-3.921 2.266,-4.144 4.473,-4.425 v -1.758 h -14.172 v 1.758",
    style: {
      fill: "#0f1f47",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 670.758,377.309 c 0,-6.528 -5.293,-11.797 -11.797,-11.797 -6.535,0 -11.828,5.269 -11.828,11.797 0,6.523 5.293,11.812 11.828,11.812 6.504,0 11.797,-5.289 11.797,-11.812",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 790.504,357.672 c 0,-6.531 -5.293,-11.813 -11.816,-11.813 -6.516,0 -11.809,5.282 -11.809,11.813 0,6.508 5.293,11.789 11.809,11.789 6.523,0 11.816,-5.281 11.816,-11.789",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 331.656,1021.21 v 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 827.797,1234.61 v 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1018.33,999.984 v 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1110.16,615.977 v 0 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 722.828,1211 c 0,-6.53 -5.285,-11.8 -11.828,-11.8 -6.523,0 -11.785,5.27 -11.785,11.8 0,6.52 5.262,11.8 11.785,11.8 6.543,0 11.828,-5.28 11.828,-11.8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1003.82,1100.47 c -0.29,-6.51 -5.797,-11.57 -12.312,-11.29 -6.504,0.27 -11.57,5.78 -11.297,12.29 0.273,6.51 5.789,11.56 12.293,11.28 6.504,-0.27 11.586,-5.77 11.316,-12.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 411.621,593.625 c 4.539,-6.535 6.832,-13.516 6.817,-20.754 -0.016,-8.25 -2.774,-14.941 -17.54,-25.164 l -42.628,-30.383 -7.848,11.289 c 0,0 43.676,31.094 44.387,31.594 7.531,5.203 10.742,9.012 10.754,14.981 0.003,3.777 -1.383,7.898 -4.114,11.835 -4.269,6.141 -9.75,8.114 -14.578,8.114 -4.387,0.011 -9.105,-3.067 -17.5,-8.926 l -40.094,-27.188 -7.699,11.075 38.149,25.851 c 10.617,7.449 19.078,12.567 26.929,12.559 11.465,-0.02 19.832,-7.481 24.965,-14.883",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 275.375,676.867 81.125,28.446 4.48,-12.293 -46.41,-56.692 58.649,23.195 4.371,-11.964 -80.188,-30.801 -4.48,12.285 46.641,56.77 -59.821,-20.93 -4.367,11.984",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 263.238,741.449 84.91,12.602 2.008,-13.602 -84.902,-12.586 -2.016,13.586",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 260.723,843.824 0.332,14.242 84.738,-34.433 -0.602,-14.133 -87.011,-25.949 0.09,14.262 70.554,19.781 -68.101,26.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 322.938,1009.85 c 5.035,9.15 8.621,12.62 13.941,12.6 1.973,0 4.461,-0.5 6.961,-1.87 3.211,-1.79 5.676,-4.76 6.594,-7.95 0.359,-1.23 0.507,-2.46 0.496,-3.7 -0.039,-5.09 -2.883,-10.223 -5.856,-15.582 l -1.758,-3.184 -24.191,12.996 z m 15.265,26.01 c -12.129,-0.02 -17.738,-6.96 -25.476,-20.96 l -10.082,-18.056 75.613,-41.031 6.527,11.804 -31.422,17.153 1.836,3.394 c 5.289,9.566 7.114,11.016 20.598,9.879 l 24.492,-2.172 6.996,12.679 -28.219,2.41 c -5.671,0.53 -10.144,0.95 -13.769,-0.1 -1.211,-0.36 -2.66,-1.09 -4.063,-2.09 0.329,1.54 0.914,3.03 0.922,4.59 0.024,2.42 -0.324,4.81 -1.047,6.99 -1.644,5.04 -5.242,9.13 -10.679,12.14 -4.059,2.24 -8.117,3.38 -12.227,3.37",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 432.148,1157.17 10.926,8.33 52.086,-68.22 -10.922,-8.34 -52.09,68.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 479.281,1190.63 55.532,28.91 5.417,-10.42 -21.609,-11.25 34.227,-65.73 -12.188,-6.34 -34.23,65.72 -21.727,-11.31 -5.422,10.42",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 617.797,1245.64 14.484,4.04 -11.652,-57.42 9.426,-32.6 -13.086,-3.78 -9.219,32.35 -40.762,42.54 14.11,4.09 29.328,-30.56 7.371,41.34",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 879.711,1128.3 43.586,73.95 41.016,-24.15 -5.969,-10.13 -29.297,17.26 -12.039,-20.46 27.558,-16.23 -5.82,-9.91 -27.57,16.25 -19.715,-33.5 -11.75,6.92",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1100.26,937.09 31.25,37.398 4.87,-14.804 -23.26,-26.625 34.56,-7.766 4.58,-13.953 -47.29,11.449 -33.59,-40.266 -4.78,14.563 25.35,29.551 -37.9,8.64 -4.63,14.082 50.84,-12.269",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1075.73,852.75 85.56,6.977 3.88,-47.45 -11.72,-0.957 -2.75,33.875 -23.67,-1.929 2.59,-31.887 -11.44,-0.93 -2.61,31.887 -38.73,-3.16 -1.11,13.574",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1120.33,710.813 c -16.73,0 -36.25,9.109 -36.25,25.964 0,6.106 2.11,14.309 9.67,19.789 5.09,3.704 11.71,5.676 19.13,5.676 8.52,0 23.87,-2.398 31.93,-13.512 2.78,-3.824 4.19,-8.265 4.16,-13.011 0,-6.578 -2.68,-14.383 -9.72,-19.489 -4.99,-3.617 -11.56,-5.417 -18.92,-5.417 z m -6.77,65.41 c -9.92,0 -19.04,-2.676 -26.25,-7.914 -12.94,-9.391 -15.3,-22.879 -15.3,-30.762 0,-29.02 27.25,-40.621 47.74,-40.621 9.83,-0.02 18.84,2.664 25.93,7.801 14.47,10.464 15.24,26.207 15.24,31.269 0,25.317 -23.26,40.227 -47.36,40.227",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1050.38,992.023 c -7.7,0 -14.66,3.231 -19.46,10.807 -2.46,3.85 -3.62,8.01 -3.66,12.22 -0.05,9.7 6.11,19.66 17.36,26.82 7.46,4.72 14.77,7.04 21.31,7.02 8.28,0 15.02,-3.64 19.5,-10.73 2.66,-4.18 3.88,-8.63 3.88,-13.07 0,-9.49 -6.01,-18.78 -16.88,-25.668 -7.62,-4.836 -15.31,-7.399 -22.05,-7.399 z m 13.37,69.927 c -8.68,0 -17.92,-2.75 -26.83,-8.4 -16.49,-10.46 -22.5,-25.45 -22.5,-36.38 0,-7.08 1.94,-14.03 6,-20.412 9.14,-14.449 22.89,-17.973 32.17,-17.934 8.85,0.051 18.21,2.981 27.01,8.578 10.62,6.735 22.45,19.238 22.45,36.188 0,7.03 -2.01,13.95 -6.08,20.37 -7.51,11.84 -19.29,17.99 -32.22,17.99",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 825.152,1162.19 c -6.222,0 -15.195,3.04 -20.226,12.2 -2.422,4.44 -3.504,9.82 -3.504,15.4 0,15.37 10.254,36.94 28.953,36.94 10.5,0 23.703,-7.82 23.703,-27.23 0,-12.37 -8.73,-37.31 -28.926,-37.31 z m 4.403,76.56 c -17.879,0 -33.465,-12.04 -39.746,-33.45 -1.387,-4.75 -2.266,-9.46 -2.266,-14.02 0,-8.57 1.437,-15.36 4.953,-21.77 7.93,-14.53 22.469,-19.48 33.504,-19.48 6.25,0 12.258,1.43 17.785,4.44 14.473,7.92 24.043,26.3 24.043,43.89 0,7.63 -1.484,14.83 -4.883,20.99 -6.972,12.66 -19.863,19.4 -33.39,19.4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 354.117,927.445 11.531,-3.254 -13.015,-47.14 -83.067,22.765 14.184,47.7 11.293,-3.196 -10.426,-34.363 22.91,-6.285 8.828,31.219 11.051,-3.141 -8.801,-31.117 25.907,-7.117 9.605,33.929",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 375.902,1106.78 c 11.926,13.37 24.118,12.45 24.118,12.45 l 2.085,-11.33 c 0,0 -9.406,-0.3 -16.769,-8.55 -3.203,-3.59 -4.813,-7.34 -4.813,-10.72 0,-2.78 1.079,-5.21 3.262,-7.16 5.949,-5.29 16.11,0.6 22.469,3.14 4.894,2.03 11.844,4.86 18.789,4.86 5.187,0 10.543,-1.47 15.441,-5.85 5.711,-5.1 8.579,-11.51 8.579,-18.24 0,-7.29 -2.833,-13.77 -8.532,-20.15 -10.953,-12.27 -25.672,-13.6 -25.672,-13.6 l -2.929,11.48 c 8.683,2 15.242,5.34 19.226,9.81 3.129,3.5 4.672,7.43 4.672,10.88 0,3.24 -1.351,6.25 -4.008,8.63 -2.136,1.91 -4.754,2.6 -7.59,2.54 -5.523,0 -12.121,-3.16 -17.582,-5.42 -10.418,-4.31 -21.421,-7.78 -31.265,1.01 -5.016,4.48 -7.68,10.11 -7.68,16.35 0,6.61 2.617,13.63 8.199,19.87",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1103.6,614.238 c -3.86,-0.008 -10.43,2.227 -12.92,8.614 -0.63,1.632 -0.88,3.281 -0.87,4.941 0.04,4.707 2.27,9.59 4.57,14.719 l 1.45,3.308 24.75,-11.121 -2.74,-6.621 c -4.62,-10.488 -7.62,-13.82 -14.24,-13.84 z m -50.68,50.899 32.46,-14.676 -1.62,-3.652 c -4.42,-9.993 -6.1,-11.614 -19.63,-11.672 l -24.58,-0.02 -5.84,-13.242 28.31,0.09 c 5.74,-0.012 10.19,-0.012 13.7,1.336 1.12,0.429 2.41,1.152 3.62,2.109 -0.09,-0.722 -0.33,-1.445 -0.33,-2.176 -0.04,-3.156 0.54,-6.281 1.75,-9.015 3.86,-9.071 14.42,-13.516 22.16,-13.496 13.67,0.019 18.9,8.183 25.53,23.222 0.24,0.559 7.97,18.391 7.97,18.391 l -78.04,35.156 -5.46,-12.355",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1038.31,519.316 c -6.81,0 -13.22,2.629 -19.89,7.95 -6.75,5.39 -13.91,13.8 -13.91,24.531 0,7.441 4.04,14.562 10.27,22.363 l 5.68,7.11 49.03,-39.122 -3.76,-4.687 c -9.09,-11.406 -15.31,-18.145 -27.42,-18.145 z m -30.59,64.622 c -8.896,-11.145 -15.654,-21.106 -15.654,-33.977 0,-10.918 4.961,-23.359 17.514,-33.379 8.33,-6.641 17.74,-10.242 27.44,-10.242 11.94,0 21.51,3.582 36.39,22.226 l 13.56,17.051 -67.09,53.555 -12.16,-15.234",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 999.742,420.656 C 919.848,392.398 845.289,394.34 781.684,408.539 c 2.082,28.414 13.828,58.766 31.816,64.41 140.09,43.457 242.12,174.063 242.12,328.008 0,189.344 -154.335,343.383 -344.034,343.383 -189.695,0 -344.023,-154.039 -344.023,-343.383 0,-105.332 49.199,-205.391 132.023,-270.273 -19.676,-8.641 -36.441,-22.618 -48.574,-40.02 -6.285,4.277 -12.336,8.711 -17.938,13.313 l -3.129,-3.137 c 3.75,-4.531 9.551,-10.496 16.539,-17.188 -10.195,-17.156 -16.101,-37.129 -16.101,-58.476 0,-3.321 0.222,-6.602 0.5,-9.844 -123.25,89.824 -196.485,232.609 -196.485,385.625 0,263.103 214.075,477.153 477.188,477.153 263.125,0 477.194,-214.05 477.194,-477.153 0,-150.703 -68.9,-289.16 -189.038,-380.301 z M 722.906,308.031 c -65.937,0 -148.222,22.399 -204.765,55.758 -17.133,10.109 -37.555,28.91 -37.555,61.035 0,8.672 1.703,16.953 4.707,24.571 21.102,-17.45 42.93,-33.805 56.598,-41.293 3.152,-1.731 4.98,-2.571 8.632,-2.571 8.797,0 15.899,7.149 15.899,15.965 0,6.738 -3.652,12.207 -9.688,14.844 -11.691,5.117 -36.168,15.223 -62.519,28.887 12.18,16.082 31.383,26.531 53.008,26.531 9.882,0 19.402,-2.117 28.281,-6.309 l 18.066,-10.527 c 57.461,-35.098 205.282,-125.09 383.77,-75.641 -67.746,-61.133 -151.192,-91.25 -254.434,-91.25 z m 56.512,-40.179 c -18.125,0 -32.996,-12.832 -32.996,-32.52 0,-19.262 15.078,-32.523 32.996,-32.523 2.727,0 5.332,0.472 7.863,1.121 -3.789,-27.27 -35.547,-57.789 -76.515,-71.508 -40.633,13.617 -72.383,44.359 -76.582,71.488 2.511,-0.648 5.109,-1.101 7.824,-1.101 19.539,0 32.996,13.691 32.996,32.523 0,17.957 -14.121,32.047 -32.293,32.449 5.547,10.149 10.879,20.93 14.793,32.5 22.539,-3.91 44.746,-6.062 65.402,-6.062 16.934,0 33.379,0.922 49.434,2.551 2.129,-9.309 5.293,-19.032 9.004,-29.071 -0.645,0.031 -1.27,0.153 -1.926,0.153 z M 546.176,526.719 c 33.918,0 65.664,-17.403 84.269,-45.274 -16.289,4.141 -32.304,9.512 -47.902,16.172 l -0.066,-0.097 -0.508,0.293 c -10.918,5.136 -22.59,7.753 -34.746,7.753 -27.032,0 -50.95,-13.261 -65.707,-33.523 -6.227,3.445 -12.438,7.07 -18.536,10.859 18.29,26.434 48.739,43.817 83.196,43.817 z m 134.289,-67.696 c -4.211,-3.125 -7.559,-6.855 -9.961,-10.957 -12.441,6.036 -28.078,13.829 -38.301,19.551 14.473,-3.203 33.379,-7.265 48.262,-8.594 z m 104.453,6.485 c -9.883,-14.102 -15.762,-33.699 -17.531,-53.539 -31.18,8.031 -59.481,18.832 -84.16,30.094 4.699,9.082 18.125,15.515 28.359,15.515 25.168,0 49.668,2.774 73.332,7.93 z m -73.332,5.871 c -21.063,0 -41.805,2.019 -62.137,5.906 -19.629,38.477 -59.844,63.235 -103.273,63.235 -10.68,0 -20.961,-1.555 -30.785,-4.27 -83.489,62.043 -133.286,160.703 -133.286,264.707 0,181.731 147.805,329.573 329.481,329.573 181.68,0 329.504,-147.842 329.504,-329.573 0,-181.727 -147.824,-329.578 -329.504,-329.578 z M 546.176,323.648 c -55.832,0 -101.25,45.543 -101.25,101.528 0,17.539 4.465,34.054 12.301,48.457 5.214,-4.727 10.785,-9.637 16.566,-14.59 -4.914,-10.41 -7.746,-21.973 -7.746,-34.219 0,-30.445 15.359,-55.605 44.422,-72.754 16.687,-9.84 35.582,-18.73 55.582,-26.461 -6.496,-1.289 -13.125,-1.961 -19.875,-1.961 z m 657.154,477.309 c 0,270.713 -220.611,490.953 -491.744,490.953 -271.133,0 -491.727,-220.24 -491.727,-490.953 0,-162.41 80.2,-313.789 214.567,-405.516 13.219,-49.211 58.234,-85.601 111.75,-85.601 14.465,0 28.496,2.742 41.828,7.898 17.996,-5.937 36.582,-10.859 55.125,-14.679 -5.223,-14.911 -12.84,-29.047 -20.106,-41.27 0,0 0.157,0.031 0.399,0.09 -0.125,-0.098 -0.281,-0.16 -0.418,-0.258 l 10.254,-10.25 c 2.597,1.438 5.566,2.32 8.75,2.32 10.117,0 18.359,-8.23 18.359,-18.359 0,-10.113 -8.242,-18.363 -18.359,-18.363 -8.84,0 -16.602,5.672 -20.664,11.722 0,0 -2.383,-8.25 -2.383,-19.14 -0.078,-35.27 38.418,-75.551 91.805,-92.539 53.351,16.597 91.836,57.187 91.828,92.476 0,12.153 -2.403,19.203 -2.403,19.203 -4.101,-4.929 -10.742,-11.722 -20.773,-11.722 -10.105,0 -18.359,8.25 -18.359,18.363 0,10.129 8.254,18.359 18.359,18.359 3.547,0 6.836,-1.05 9.66,-2.812 L 799,260.82 c 0.223,-0.058 0.379,-0.101 0.379,-0.101 -5.625,13.453 -9.715,25.801 -12.508,37.672 88.418,11.898 163.008,49.328 222.309,111.691 l -0.02,0.059 c 123.38,93.765 194.17,236.031 194.17,390.816",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path162"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxBrandCmykPosRect);
export default __webpack_public_path__ + "static/media/ox_brand_cmyk_pos_rect.2e163fe6eb7cb7b6e028590f6041ae7f.svg";
export { ForwardRef as ReactComponent };